import React from 'react'
import Fragment from '../common/fragment'


function FragmentBB(props) {
  return (
    <Fragment pos="bb" {...props}>
      <p>
En esta gráfica no hay personas, pero se distribuyen los cuerpos de distintas
maneras: cuerpos vivos o muertos; cuerpos biológicos o maquínicos; cuerpos de
metal o carne; cuerpos inmortales o caducos. La muerte es la curva. La vida, un
punto en la distribución de las variables. El eje vertical se eleva como las
chimeneas; el horizontal se extiende como la Tierra. Las abejas vuelan a través del
espacio sideral que ambos cobijan. El Muñeco estará escondido. Las moscas vuelan
desde abajo −la muerte− hacia arriba. Los cuerpos sanos estarán rodeados de abejas
y moscas.
      </p>
    </Fragment>
  )
}


export default FragmentBB
